import React, { Component } from 'react';

/** header component of web app */ 
class Header extends Component {
    render() {
        return(
            <h1 class="header">EDU Vibe</h1>
        );
    }
}

export default Header;